(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-with-text"] && !Shopify.designMode) return;
  try {
    
// JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();
})();
